import request from '@/config/axios'

export interface PortalSolutionTabVO {
  id?: number
  tabKey: string
  name: string
  listPage: boolean
  sort: number
  status: number
  createTime?: string
}

export interface PortalSolutionEntryVO {
  id?: number
  tabKey: string
  title: string
  shortName: string
  summary?: string
  effect?: string
  industry?: string
  slug?: string
  linkUrl?: string
  icon?: string
  color?: string
  coverImage?: string
  products?: string
  recommend: boolean
  sort: number
  status: number
  createTime?: string
}

export const getPortalSolutionTabPage = (params: PageParam & { name?: string; tabKey?: string; status?: number }) =>
  request.get({ url: '/portal-ops/portal-solution-tab/page', params })

export const getPortalSolutionTab = (id: number) =>
  request.get({ url: '/portal-ops/portal-solution-tab/get?id=' + id })

export const createPortalSolutionTab = (data: PortalSolutionTabVO) =>
  request.post({ url: '/portal-ops/portal-solution-tab/create', data })

export const updatePortalSolutionTab = (data: PortalSolutionTabVO) =>
  request.put({ url: '/portal-ops/portal-solution-tab/update', data })

export const deletePortalSolutionTab = (id: number) =>
  request.delete({ url: '/portal-ops/portal-solution-tab/delete?id=' + id })

export const getPortalSolutionEntryPage = (
  params: PageParam & { tabKey?: string; title?: string; status?: number }
) => request.get({ url: '/portal-ops/portal-solution-entry/page', params })

export const getPortalSolutionEntry = (id: number) =>
  request.get({ url: '/portal-ops/portal-solution-entry/get?id=' + id })

export const createPortalSolutionEntry = (data: PortalSolutionEntryVO) =>
  request.post({ url: '/portal-ops/portal-solution-entry/create', data })

export const updatePortalSolutionEntry = (data: PortalSolutionEntryVO) =>
  request.put({ url: '/portal-ops/portal-solution-entry/update', data })

export const deletePortalSolutionEntry = (id: number) =>
  request.delete({ url: '/portal-ops/portal-solution-entry/delete?id=' + id })
